import { Controller } from "@hotwired/stimulus"

// Selecting models in a library — to attribute them to a brand, to export
// them, or both.
//
// The bar stays out of the way until something is ticked: an operator browsing
// the library should not have to look at a form they are not using. Everything
// it needs travels in the form itself, so a submit carries the selection
// without any of the cards being inside it — each tick writes a hidden input
// into the bar and each untick removes it.
//
// `ids` is plural because a bar can hold more than one form (attribute AND
// export), and the same ticked set has to reach whichever one is pressed.
export default class extends Controller {
  static targets = ["bar", "count", "ids", "submit"]

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  clear() {
    this.boxes.forEach((box) => { box.checked = false })
    this.sync()
  }

  get boxes() {
    return Array.from(this.element.querySelectorAll("[data-model-assign-box]"))
  }

  sync() {
    const picked = this.boxes.filter((box) => box.checked)

    this.idsTargets.forEach((slot) => {
      slot.innerHTML = ""
      picked.forEach((box) => {
        const field = document.createElement("input")
        field.type = "hidden"
        field.name = "model_ids[]"
        field.value = box.value
        slot.appendChild(field)
      })
    })

    // The card reads as picked, not just its checkbox.
    this.boxes.forEach((box) => {
      const card = box.closest(".model-comp-card")
      if (card) card.classList.toggle("model-comp-card--picked", box.checked)
    })

    this.barTarget.hidden = picked.length === 0
    this.countTargets.forEach((el) => { el.textContent = picked.length })
    this.submitTargets.forEach((el) => { el.disabled = picked.length === 0 })
  }
}
